import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

/**
 * Emits a single <link rel="canonical"> tag for the current route,
 * stripping all query parameters and fragment hashes. Trailing slashes
 * are removed from every path except "/" to match the sitemap convention.
 *
 * Mount once per page surface (Layout for routes wrapped in Layout,
 * or directly in non-Layout public pages). Per-page Helmet blocks must
 * NOT emit their own <link rel="canonical"> — react-helmet-async does not
 * dedupe <link> tags, so double canonicals would ship to the DOM.
 */
const ORIGIN = "https://jobs.auditfriendly.co";

export default function RouteCanonical() {
  const { pathname } = useLocation();
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  let decoded = normalized;
  try {
    decoded = decodeURI(normalized);
  } catch {
    // malformed URI — fall back to the raw pathname
  }
  const href = `${ORIGIN}${decoded}`;
  return (
    <Helmet>
      <link rel="canonical" href={href} />
    </Helmet>
  );
}
